import { apiSlice } from "./apiSlice";

export const commercialSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllCommercial: builder.query({
            query: (params) => ({
                url: `CommercialAsset`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["CommercialTracker"],
        }),

        createCommercial: builder.mutation({
            query: ({ body }) => ({
                url: `CommercialAsset`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["CommercialTracker"],
        }),

        updateCommercial: builder.mutation({
            query: ({ body }) => ({
                url: `CommercialAsset`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["CommercialTracker"],
        }),
        getExportCommercialAsset: builder.query({
            query: (params) => ({
                url: `CommercialAsset`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

    }),
});

export const { useLazyGetAllCommercialQuery, useCreateCommercialMutation, useUpdateCommercialMutation, useLazyGetExportCommercialAssetQuery } = commercialSlice;